import React, { useEffect, useState, useCallback } from "react";
import { ApiService } from "../../../../services/ApiService";
import { useAlert } from "react-alert";
import { SystemConfigNavbar } from "../reusedcomponent/Navbar";
import CreateLeaveModal from "./modal/create_leave";
import EditLeaveModal from "./modal/edit_leave";
import useModal from "../../../../utils/useModal";
import { ConfirmTemplate } from "../../../../components/confirm";
import { PageBody } from "../../../../components/loader";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";
import Modal from "react-modal";

import { systemConfigThunk } from "../../../../store/actions/systemconfiguration/systemconfig.thunk";
import { useDispatch, useSelector } from "react-redux";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const SystemConfigLeave = () => {
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const alert = useAlert();
  const [EditValue, setEditValue] = useState([]);
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  const { modalIsOpen, openModal, closeModal } = useModal();

  const openEditModal = () => {
    setOpen(true);
  };

  console.log("leaves", allLeaves);

  const closeEditModal = () => {
    setOpen(false);
  };

  const { allLeaves } = useSelector((state) => state.systemConfig);
  const dispatch = useDispatch();

  const getAllLeavess = useCallback(async () => {
    updateLoader(true, "Loading leave");
    setLoader(true);
    await dispatch(systemConfigThunk.getAllLeaves());
    setLoader(false);
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getAllLeavess();
  }, []);

  const resetYear = async () => {
    const res = await ApiService.get(`leaves/reset-leave`);
    if (res.data.type === false) {
      alert.error(res.data.msg);
    } else if (res.data.type === true) {
      alert.success(res.data.msg);
      getAllLeavess();
    }
  };

  const deleteLeave = (leave_id) => {
    const request = async () => {
      const res = await ApiService.delete(`leaves/delete-leave/${leave_id}`);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getAllLeavess();
      }
    };
    ConfirmTemplate(
      {
        title: "Delete Leave",
        message: "Are You Sure You Want To Delete This Leave",
      },
      request
    );
  };

  return (
    <PageBody isLoading={isLoading} message={message}>
      <React.Fragment>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="assign cases modal"
        >
          <CreateLeaveModal
            alert={alert}
            closeModal={closeModal}
            getLeave={getAllLeavess}
          />
        </Modal>
        <Modal
          isOpen={open}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="assign cases modal"
        >
          <EditLeaveModal
            alert={alert}
            getLeave={getAllLeavess}
            value={EditValue}
            closeModal={closeEditModal}
          />
        </Modal>
        <SystemConfigNavbar />
        <div class="row container">
          <div class="col-sm-12 col-md-12 col-xs-12">
            <div class="table-wrapper table-responsive">
              <div class="table-title">
                <div class="row">
                  <div class="col-sm-6">
                    <h2>
                      <b>LEAVE </b>{" "}
                    </h2>
                  </div>
                  <div class="col-sm-6">
                    <button
                      onClick={openModal}
                      class="btn nt-button-color-action trigger-btn"
                      data-toggle="modal"
                    >
                      <i class="material-icons">&#xE147;</i>{" "}
                      <span> CREATE LEAVE </span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12">
                  <div class="registration-form">
                    <table class="table table-bordered asset-table job-title dtMaterialDesignExample">
                      <thead>
                        <tr>
                          <th class="th-sm">NO</th>
                          <th class="th-sm">LEAVE TYPE</th>
                          <th class="th-sm">NO OF DAYS</th>

                          <th class="th-sm">ACTIVE YEAR</th>
                          <th class="th-sm">ACTION</th>
                        </tr>
                      </thead>
                      <tbody id="job_title">
                        {allLeaves.map((leave, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{leave.type.toUpperCase()}</td>
                            <td>{leave.number_of_days}</td>
                            <td> {leave.active_year}</td>
                            <td>
                              <div class="dropdown">
                                <a
                                  class="dropdown-toggle card-drop arrow-none"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <h3 class="m-0 text-muted">
                                    <i class="fa fa-ellipsis-v"></i>
                                  </h3>
                                </a>
                                <div
                                  id="dropdown_wrapper"
                                  class="dropdown-menu dropdown-menu-right dropdown_wrapper"
                                  aria-labelledby="btnGroupDrop1"
                                >
                                  <a
                                    class="dropdown-item"
                                    onClick={() => {
                                      deleteLeave(leave.id);
                                    }}
                                  >
                                    Delete
                                  </a>

                                  <a
                                    onClick={() => {
                                      const value = {
                                        id: leave.id,
                                        type: leave.type,
                                        number_of_days: leave.number_of_days,
                                        year: leave.active_year,
                                      };
                                      setEditValue(value);
                                      openEditModal();
                                    }}
                                    class="edit dropdown-item"
                                  >
                                    <span>Edit</span>
                                  </a>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="float-left"> </div>
                    <div className="float-right">
                      <button
                        type="button"
                        onClick={resetYear}
                        class="btn btn-primary btn-sm"
                      >
                        Reset Year
                      </button>
                    </div>
                    <span className="clearfix"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </PageBody>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/systemconfiguration/leave/index.js